// src/page/main/storagePage/header/createVolume/CreateVolumex
import React, { useState, useEffect } from "react";
import {
  Overlay,
  Dialog,
  Header,
  Title,
  Desc,
  Form,
  Field,
  Label,
  Input,
  Row,
  Actions,
  Button,
  FieldHint,
  ApiError,
  Select,
} from "./styles";
import { useTaskStore } from "store/task";
import { storageAPI } from "api";

const CreateVolume = ({ isOpen, onClose, aggregates, svms, defaultSvm }) => {
  const { addTask } = useTaskStore();

  const [svmname, setSvmname] = useState("");
  const [aggrname, setAggrname] = useState("");
  const [volname, setVolname] = useState("");
  const [volsize, setVolsize] = useState("");
  const [path, setPath] = useState("");

  const [apiErr, setApiErr] = useState<string | null>(null);

  const pathInvalid = path.trim().length > 0 && !path.startsWith("/");

  const allFilled = svmname && aggrname && volname && volsize && path;
  const canSubmit = Boolean(allFilled) && !pathInvalid;

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;

    try {
      setApiErr(null);
      const sizeNorm = volsize.replace(/\s+/g, "");
      const res = await storageAPI.createVolumes(
        svmname,
        volname,
        path,
        sizeNorm,
        aggrname
      );

      addTask({
        name: volname,
        id: res?.data.task_id,
        job: `Create Volume`,
        state: "pending",
      });

      Close();
    } catch (error: any) {
      setApiErr(error?.message || "Failed to create volume.");
    }
  };

  const Close = () => {
    setSvmname("");
    setAggrname("");
    setVolname("");
    setVolsize("");
    setPath("");
    onClose();
  };

  useEffect(() => {
    if (isOpen && defaultSvm) {
      setSvmname(defaultSvm);
    }
  }, [isOpen, defaultSvm]);

  if (!isOpen) return null;

  return (
    <Overlay
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) {
          e.preventDefault();
          e.stopPropagation();
        }
      }}
    >
      <Dialog role="dialog" tabIndex={-1}>
        <Header>
          <Title id="create-volume-title">Create Volume</Title>
        </Header>

        <Desc>SVM에 볼륨을 생성을 합니다.</Desc>

        {apiErr && <ApiError role="alert">{apiErr}</ApiError>}

        <Form onSubmit={onSubmit}>
          <Field>
            <Label>Aggregate</Label>
            <Select
              value={aggrname}
              onChange={(e) => setAggrname(e.target.value)}
            >
              <option value="" disabled>
                Select Aggregate
              </option>
              {aggregates.map((a) => (
                <option key={a} value={a}>
                  {a}
                </option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>SVM</Label>
            <Select
              value={svmname}
              onChange={(e) => setSvmname(e.target.value)}
            >
              <option value="" disabled>
                Select SVM
              </option>
              {svms.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </Select>
          </Field>

          <Field>
            <Label>Volume Name</Label>
            <Input
              value={volname}
              onChange={(e) => setVolname(e.target.value)}
              placeholder="ex) vol_database01"
            />
          </Field>

          <Row>
            <Field>
              <Label>Volume Size (TB)</Label>
              <Input
                type="number"
                value={volsize}
                onChange={(e) => setVolsize(e.target.value)}
                placeholder="ex) 1"
                inputMode="decimal"
              />
            </Field>

            <Field>
              <Label $invalid={pathInvalid}>Mount Path</Label>
              <Input
                value={path}
                onChange={(e) => setPath(e.target.value)}
                placeholder="ex) /oasys01"
                $invalid={pathInvalid}
              />
              {pathInvalid && <FieldHint>Path must start with “/”.</FieldHint>}
            </Field>
          </Row>

          <Actions>
            <Button type="button" onClick={Close} data-variant="ghost">
              Cancel
            </Button>
            <Button type="submit" disabled={!canSubmit}>
              Create
            </Button>
          </Actions>
        </Form>
      </Dialog>
    </Overlay>
  );
};

export default CreateVolume;
